import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import BaseInputField from './baseInput'

const getIloks = R.compose(
  R.join(','),
  R.defaultTo([])
)

const IlokField = ({
  name,
  width,
  onChange,
  ilokAccounts,
  readOnly = false
}) => (
  <BaseInputField
    readOnly={readOnly}
    name = {name}
    width = {width}
    onChange = {onChange}
    value = {getIloks(ilokAccounts)}
    labelTxt = 'iLok Accounts (comma separated)'
    popupTxt = 'For users that want ilok, please write in their ilok account name.  Otherwise, leave blank.'
  />
)

IlokField.propTypes = {
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  ilokAccounts: PropTypes.array.isRequired,
  readOnly: PropTypes.bool
}
export default IlokField



// WEBPACK FOOTER //
// ./webAdmin/forms/ilokField.js